import { z } from "zod";
import { createEndpoint, createEndpointWithPagination } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    LeadClientResponseSchema,
    ClientListLeadsQueryParams,
    CreateLeadRequest,
} from "../schemas/leads-v2";

export function createClientLeadsV2Api(http: HttpClient, baseUrl: string) {
    const clientBaseUrl = `${baseUrl}/client/leads-v2`;

    return {
        /**
         * Submit a new project lead
         * POST /api/v2/client/leads-v2
         */
        submitLead: createEndpoint<
            z.infer<typeof LeadClientResponseSchema>,
            CreateLeadRequest,
            QueryParams
        >(http, "POST", "", {
            base: clientBaseUrl,
            responseSchema: LeadClientResponseSchema,
        }),

        /**
         * List all leads submitted by the authenticated client
         * GET /api/v2/client/leads-v2
         */
        listLeads: createEndpointWithPagination<
            z.infer<typeof LeadClientResponseSchema>,
            unknown,
            unknown,
            ClientListLeadsQueryParams
        >(http, "GET", "", {
            base: clientBaseUrl,
            itemSchema: LeadClientResponseSchema,
        }),

        /**
         * Get a single lead by ID (must belong to authenticated client)
         * GET /api/v2/client/leads-v2/:id
         */
        getLead: createEndpoint<
            z.infer<typeof LeadClientResponseSchema>,
            unknown,
            QueryParams,
            { id: number }
        >(http, "GET", "/:id", {
            base: clientBaseUrl,
            responseSchema: LeadClientResponseSchema,
            params: ["id"],
        }),
    };
}

export type ClientLeadsV2Api = ReturnType<typeof createClientLeadsV2Api>;

